module.exports = __webpack_public_path__ + "img/model15x5x24.702ed630.png";